import { j as e } from "../../../node_modules/react/jsx-runtime.js";
import { useState as Z } from "react";
import _ from "../../../node_modules/lodash/uniqueId.js";
import { clsx as f } from "../../../node_modules/clsx/dist/clsx.m.js";
import j from "../Icon/Icon.js";
import t from "./TextField.module.scss.js";
import { Typography as $ } from "../Typography/Typography.js";
import q from "../Tooltip/Tooltip.js";
import b from "../Button/Button.js";
import { FieldLabel as z } from "./components/FieldLabel/FieldLabel.js";
import O from "./components/FieldHelperText/FieldHelperText.js";
const xe = ({
  label: a,
  optionalLabel: p,
  required: u,
  labelIconTooltip: d,
  helperTextIcon: i,
  helperTextIconTooltip: H,
  placeholder: K,
  prefix: N,
  suffix: F,
  value: D,
  type: A = "text",
  size: c = "regular",
  leadingIcon: v,
  leadingIconTooltip: T,
  trailingIcon: o,
  trailingIconTooltip: w,
  helperText: y = "",
  disabled: m = !1,
  ref: G,
  testId: J,
  status: E,
  id: M,
  maxWidth: P,
  direction: Q,
  trailingButton: l,
  autoComplete: U = "off",
  readOnly: s = !1,
  onChange: h,
  onFocus: V,
  onClickLeadingIcon: x,
  ...W
}) => {
  const [X] = Z(() => _("")), R = M || X, Y = (r) => {
    s || h == null || h(r.target.value, r);
  };
  return /* @__PURE__ */ e.jsxs(
    k,
    {
      size: c,
      disabled: m,
      maxWidth: P,
      direction: Q,
      children: [
        a && /* @__PURE__ */ e.jsx(
          z,
          {
            label: a,
            optionalLabel: p,
            required: u,
            disabled: m,
            tooltipText: d,
            size: c,
            htmlFor: R,
            withTextField: !0
          }
        ),
        /* @__PURE__ */ e.jsxs(
          "div",
          {
            ref: G,
            className: f(t.textField, t[c], {
              [t.textFilled]: !!D,
              [t.readOnly]: s
            }),
            "aria-disabled": m,
            "data-destructive": E === "destructive",
            children: [
              N && /* @__PURE__ */ e.jsx("div", { className: t.prefix, children: /* @__PURE__ */ e.jsx(
                $,
                {
                  text: N,
                  variant: "interface/default/s",
                  textColor: "color/fg/lighter"
                }
              ) }),
              v && (!m && T ? /* @__PURE__ */ e.jsx(
                q,
                {
                  trigger: /* @__PURE__ */ e.jsx("div", { className: t.leadingIcon, children: /* @__PURE__ */ e.jsx(j, { name: v }) }),
                  title: T
                }
              ) : /* @__PURE__ */ e.jsx(
                "div",
                {
                  onClick: (r) => {
                    if (s)
                      return r.preventDefault();
                    x == null || x();
                  },
                  onKeyDown: (r) => {
                    if (s)
                      return r.preventDefault();
                    (r.key === "Enter" || r.key === " ") && (x == null || x());
                  },
                  role: "button",
                  tabIndex: 0,
                  className: f(t.leadingIcon, x && "cursor-pointer"),
                  children: /* @__PURE__ */ e.jsx(j, { name: v })
                }
              )),
              /* @__PURE__ */ e.jsx(
                "input",
                {
                  ...W,
                  id: R,
                  type: A,
                  placeholder: K,
                  value: D,
                  onChange: Y,
                  onFocus: V,
                  disabled: m,
                  "data-testid": J,
                  autoComplete: U,
                  readOnly: s,
                  className: f({
                    [t.readOnly]: s
                  })
                }
              ),
              o && /* @__PURE__ */ e.jsx("div", { className: t.trailingIcon, children: o && (!m && w ? /* @__PURE__ */ e.jsx(
                q,
                {
                  trigger: /* @__PURE__ */ e.jsx(
                    j,
                    {
                      name: o,
                      color: "color/fg/lighter"
                    }
                  ),
                  title: w
                }
              ) : /* @__PURE__ */ e.jsx(j, { name: o })) }),
              F && /* @__PURE__ */ e.jsx("div", { className: t.suffix, children: /* @__PURE__ */ e.jsx(
                $,
                {
                  text: F,
                  variant: "interface/default/s",
                  textColor: "color/fg/lighter"
                }
              ) }),
              l && /* @__PURE__ */ e.jsx("div", { className: `${t.suffix} !p-0`, children: /* @__PURE__ */ e.jsx(
                b,
                {
                  color: "neutral",
                  ...l,
                  className: f(l.className, {
                    [t.trailingButtonReadOnly]: s
                  }),
                  onClick: (r) => {
                    var S;
                    s ? r.preventDefault() : (S = l.onClick) == null || S.call(l, r);
                  },
                  variant: "ghost"
                }
              ) })
            ]
          }
        ),
        (y || i) && /* @__PURE__ */ e.jsx(
          O,
          {
            label: y,
            disabled: m,
            icon: i,
            tooltipText: H,
            status: E,
            withTextField: !0
          }
        )
      ]
    }
  );
}, k = ({
  disabled: a,
  size: p,
  maxWidth: u,
  direction: d,
  children: i
}) => /* @__PURE__ */ e.jsx(
  "div",
  {
    className: f(
      t.fieldContainer,
      t[`container-${p}`],
      a && t.disabled
    ),
    style: { maxWidth: u, direction: d },
    children: i
  }
);
export {
  k as FieldContainer,
  xe as default
};
//# sourceMappingURL=TextField.js.map
